import { TableStateFilterEvent } from '@purespectrum1/ui/table';
import { GetSurveysFilterQueryParams } from '../../../shared/services/buyer-api/types/get-surveys.interface';
import { Constants } from '../../dashboard-constants';
import { DashboardFilter } from './dashboard-filter';
import {
  SURVEY_FILTER_FIELDS,
  SURVEY_TABLE_FIELD_TO_FILTER_MAP,
} from './dashboard-filtering.constants';

type TableFilter = TableStateFilterEvent;

export class DashboardFiltering {
  private readonly _tableHeaders = Constants.SURVEY_LISTING_TABLE_HEADERS;

  private constructor(public readonly tableFilters: TableFilter[]) {}

  public static empty(): DashboardFiltering {
    return new DashboardFiltering([]);
  }

  public static from(filters: TableFilter[] = []): DashboardFiltering {
    const _filters = filters.filter(
      (filter) => !!SURVEY_TABLE_FIELD_TO_FILTER_MAP[filter.field]
    );

    return new DashboardFiltering(_filters);
  }

  public request(): GetSurveysFilterQueryParams {
    const filters = this._filters();
    return filters
      .filter((filter) => filter.applicable())
      .reduce(
        (params, filter) => ({ ...params, [filter.field]: filter.values() }),
        {}
      );
  }

  private _filters(): DashboardFilter[] {
    return this.tableFilters
      .filter((filter) => !!SURVEY_TABLE_FIELD_TO_FILTER_MAP[filter.field])
      .flatMap(({ field, values, customValues }) => {
        const _values = customValues?.length ? customValues : values;

        if (field === this._tableHeaders.HEALTH_CHECK) {
          return this._healthCheck(_values);
        }

        const fieldDetails = this._fieldDetails(field);
        return DashboardFilter.create(fieldDetails, _values);
      });
  }

  private _healthCheck(values: string[] = []): DashboardFilter[] {
    const alertField = this._fieldDetails(this._tableHeaders.HEALTH_CHECK);
    const alertLevelField = this._fieldDetails(
      SURVEY_FILTER_FIELDS.HEALTH_CHECK_ALERT_LEVEL
    );

    const alertFilterValues = values.filter((value) =>
      Constants.HEALTH_CHECK.METRIC_OPTIONS.includes(value)
    );

    const alertLevelFilterValues = values.filter((value) =>
      Constants.HEALTH_CHECK.ALERT_OPTIONS.includes(value)
    );

    return [
      DashboardFilter.create(alertField, alertFilterValues),
      DashboardFilter.create(alertLevelField, alertLevelFilterValues),
    ];
  }

  private _fieldDetails(tableField: string) {
    return SURVEY_TABLE_FIELD_TO_FILTER_MAP[tableField];
  }
}
